import { render } from "./ChangePasswordView.vue?vue&type=template&id=465cd733&scoped=true"
import script from "./ChangePasswordView.vue?vue&type=script&lang=js"
export * from "./ChangePasswordView.vue?vue&type=script&lang=js"

import "./ChangePasswordView.vue?vue&type=style&index=0&id=465cd733&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-465cd733"]])

export default __exports__